<template>
  <div>
    <ul class="nav" ref="nav">
      <!-- <li class="">
        <router-link to='/Index'>企业介绍</router-link>
      </li>
      <li style="position: relative">
        <router-link to='/Product'>产品列表</router-link>
      </li>
      <li class="current">
        <router-link to='/Video'>实时监控</router-link>
      </li> -->
      <li v-for="(item, index) in navList" :class="{current: active==item.reds}" :key="index" @click="changeActive(index+1)" >
        <router-link :to='item.path'>{{item.name}}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'NavBar',
    data() {
      return {
        active: '1',
        navList:[{
          reds:'1',
          name: '企业介绍',
          path: '/Index'
        },
        {
          reds:'2',
          name: '产品列表',
          path: '/Product'
        },
        {
          reds:'3',
          name: '实时监控',
          path: '/Video'
        }]
      }
    },
    computed: {
      
    },
    methods: {
      changeActive(index){
        this.active = index;
      },
    },
    mounted () {
      // console.log(this.$refs.nav);
    },
  }
</script>

<style lang="scss" scoped>
// @import "../assets/css/base.scss";
</style>


// WEBPACK FOOTER //
// src/views/NavBar.vue